import React, { useEffect } from 'react';
import event from '~helpers/mixpanel';
import API_TOKEN_ONE from '~css/imgs/api-token-one.png';
import API_TOKEN_TWO from '~css/imgs/api-token-two.png';
import { useTranslation } from 'react-i18next';

const ApiTokenHelp = () => {
  const { t } = useTranslation();
  useEffect(() => {
    event('Viewed News in Help Center Page', { 'Function Name': 'API Token' });
  }, []);
  return (
    <div className="apiToken-help">
      <div className="apiToken-help__box">
        <div className="common__title">{t('landlord.new_dashboard.api-token-help.title')}</div>
        <div className="apiToken-help__desc">
          {t('landlord.new_dashboard.api-token-help.first')}
        </div>
        <div className="apiToken-help__step">
          {t('landlord.new_dashboard.api-token-help.second')}
        </div>
        <div className="apiToken-help__ImgOne">
          <div className="common__imgbox">
            <img src={API_TOKEN_ONE} alt={t('landlord.new_dashboard.api-token-help.title')} />
          </div>
        </div>
        <div className="apiToken-help__step">
          {t('landlord.new_dashboard.api-token-help.third')}
        </div>
        <div className="common__imgbox">
          <img src={API_TOKEN_TWO} alt={t('landlord.new_dashboard.payment-plan-help.title')} />
        </div>
      </div>
    </div>
  );
};
export default ApiTokenHelp;
